import { useEffect, useState } from "react";

const CHANGED_ITEM_EVENT = "localStorage:setItem";

export default function useLocalStorageItem(
  key: string,
): [string | null, (newValue: string) => void] {
  const [value, setValue] = useState<string | null>(null);

  useEffect(() => {
    setValue(localStorage.getItem(key));
  }, [setValue, key]);

  useEffect(() => {
    const listener = () => setValue(localStorage.getItem(key));
    document.addEventListener(CHANGED_ITEM_EVENT, listener);
    return () => document.removeEventListener(CHANGED_ITEM_EVENT, listener);
  });

  return [
    value,
    (newValue: string) => {
      localStorage.setItem(key, newValue);
      document.dispatchEvent(new Event(CHANGED_ITEM_EVENT));
      setValue(newValue);
    },
  ];
}
